module.exports = __webpack_public_path__ + "static/media/比赛3.117837aa.jpg";